import React from "react";
import { X, Loader2, Send } from "lucide-react";

/**
 * NotifyTeamModal — extracted from ChatsPage.jsx (iter 156.2, Feb 2026).
 *
 * Manual chat-to-Sales / Customer-Support email handoff. Recipients
 * + reasons are configurable in Settings → Team notifications.
 */
export const NotifyTeamModal = ({
  open,
  onClose,
  notifyTeamConfig,
  notifyRecipient,
  setNotifyRecipient,
  notifyReason,
  setNotifyReason,
  notifyNote,
  setNotifyNote,
  notifySending,
  onSend,
}) => {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 bg-black/40 z-[70] flex items-center justify-center p-4"
      onClick={() => !notifySending && onClose()}
      data-testid="notify-team-modal"
    >
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md animate-scale-in" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between p-4 border-b border-[--border]">
          <div className="flex items-center gap-2">
            <span className="w-8 h-8 rounded-lg bg-indigo-50 text-indigo-700 flex items-center justify-center"><Send size={16} /></span>
            <h2 className="text-sm font-semibold" style={{ fontFamily: "Playfair Display, serif" }}>Notify a team about this chat</h2>
          </div>
          <button onClick={() => !notifySending && onClose()} className="btn-icon"><X size={16} /></button>
        </div>
        <div className="p-4 space-y-3">
          <div>
            <label className="block text-[11px] font-bold uppercase tracking-wider text-[--text-muted] mb-1.5">Send to</label>
            <select
              value={notifyRecipient}
              onChange={(e) => setNotifyRecipient(e.target.value)}
              className="w-full border-2 border-[--border] rounded-xl px-3 py-2 text-xs outline-none focus:border-indigo-300 bg-white"
              data-testid="notify-team-recipient"
            >
              <option value="">Choose a team…</option>
              {(notifyTeamConfig.recipients || []).map((r) => (
                <option key={r.email} value={r.email}>{r.label} — {r.email}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-[11px] font-bold uppercase tracking-wider text-[--text-muted] mb-1.5">Reason</label>
            <select
              value={notifyReason}
              onChange={(e) => setNotifyReason(e.target.value)}
              className="w-full border-2 border-[--border] rounded-xl px-3 py-2 text-xs outline-none focus:border-indigo-300 bg-white"
              data-testid="notify-team-reason"
            >
              <option value="">Choose a reason…</option>
              {(notifyTeamConfig.reasons || []).map((r) => (
                <option key={r.value} value={r.value}>{r.icon ? `${r.icon}  ` : ""}{r.label}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-[11px] font-bold uppercase tracking-wider text-[--text-muted] mb-1.5">Note (optional)</label>
            <textarea
              value={notifyNote}
              onChange={(e) => setNotifyNote(e.target.value)}
              placeholder="Add any context for the team…"
              rows={3}
              className="w-full border-2 border-[--border] rounded-xl px-3 py-2 text-xs outline-none focus:border-indigo-300 resize-none"
              data-testid="notify-team-note"
            />
          </div>
          <p className="text-[10px] text-[--text-muted] leading-snug">
            The email includes the customer name, WhatsApp number, the last few messages, and a deep link to this chat. Recipients & reasons can be edited in <strong>Settings → Team notifications</strong>.
          </p>
          <button
            disabled={notifySending || !notifyRecipient || !notifyReason}
            onClick={onSend}
            className="w-full py-2.5 rounded-full text-sm font-bold text-white flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
            style={{ background: "linear-gradient(135deg, #4F46E5, #312E81)" }}
            data-testid="notify-team-send-btn"
          >
            {notifySending ? <Loader2 size={14} className="animate-spin" /> : <Send size={14} />}
            {notifySending ? "Sending…" : "Send notification"}
          </button>
        </div>
      </div>
    </div>
  );
};
